export var currencies = ['JPY', 'EUR', 'USD', 'KRW', 'TWD'];
export var currencyOptions = currencies.reduce(function (options, currency) {
    options[currency] = currency;
    return options;
}, {});
export var currencyItems = currencies.map(function (currency) { return ({
    value: currency,
    text: currency,
}); });
